import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import * as FileSaver from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '@core/services/dialog.service';
import { MessageService } from '@core/services/message.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { RoleEnum } from '@core/models/role';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AppSignalDataService } from 'src/app/app-signal-data.service';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { ObservacoesModalComponent } from '../observacoes-modal/observacoes-modal.component';
import { RouteAction } from '@core/action/action';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { ObservacoesFormComponent } from '../observacoes-form/observacoes-form.component';
import dayjs from 'dayjs';
import { addFormControls } from '@shared/util/util';

@Component({
  selector: 'app-observacoes-list',
  templateUrl: './observacoes-list.component.html',
  styleUrls: ['./observacoes-list.component.scss']
})
export class ObservacoesListComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(ObservacoesFormComponent) observacoesFormComponent!: ObservacoesFormComponent;

  @Input() entidadeForm!: FormGroup;
  @Input() entidade: any;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  @Output() dadosObservacoesEmit = new EventEmitter<any>();

  observacoesFilterForm!: FormGroup;
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  statusObservacoes: any[] = [];
  empresas: any[] = [];
  statusObservacoess: any[] = [];

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposObservacoes: any[] = [];
  observacoessSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  nzpage = 0;
  total = 0;
  nzFilterOption = (): boolean => true;

  loading = false;
  observacoes: any;

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,

    private modalService: NzModalService,
    private appSignalDataService: AppSignalDataService,
    private entidadeSharedDataService: EntidadeSharedDataService
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }

  ngOnChanges(): void {
    if (this.entidade && this.entidade.entidadeObservacoes) {
      const observacoess = this.entidade.entidadeObservacoes;
      this.dataSet = observacoess;
    }
  }

  ngAfterViewInit(): void {
    // this.observacoesFormComponent.dadosObservacoesEmit.subscribe(res => {
    //   const index = this.dataSet.findIndex(item => item.id === res.id);
    //   res.dataCadastro = dayjs().format('DD/MM/YYYY');
    //   if (index !== -1) {
    //     this.dataSet[index] = res;
    //     this.enviarDados();
    //   } else {
    //     this.dataSet.push(res);
    //     this.enviarDados();
    //   }
    // })

    this.entidadeSharedDataService?.resetForm$.subscribe(res => {
      if (res) {
        this.dataSet = [];
      }
    })
  }

  ngOnInit(): void {
    this.construirForm();
  }

  construirForm() {
    addFormControls(this.entidadeForm, {
      entidadeObservacoes: []
    });
  }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  sort(event: any) {
    let column = event.sort.find((x: any) => x.value);
    if (column) {
      let order = new ColumnOrder();
      order.value = column.value;
      order.key = column.key;
      this.columOrder = order;
    } else {
      this.columOrder = undefined;
      this.dataSet = this.dataSet;
    }
  }

  showModalEdicao(obj: any): void {
    this.showModal(obj, RouteAction.Editar);
  }

  showModalInclusao(): void {
    this.showModal(null, RouteAction.Inserir);
  }

  showModal(obj?: any, acao?: RouteAction): void {
    const config: ModalOptions<ObservacoesModalComponent> = {
      nzTitle: 'Entidade Observacoes',
      nzContent: ObservacoesModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '69vw',
      nzClosable: false
    };
    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.observacoes = obj;
    modalRef.componentInstance!.acao = acao ? RouteAction.Editar : RouteAction.Inserir;

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        if (obj) {
          const index = this.dataSet.findIndex(item => item.id === obj.id);
          this.dataSet[index] = result;
          this.enviarDados();
        } else {
          this.dataSet.push(result);
          this.enviarDados();
        }
      }
    });
  }

  editarItem(obj: any) {
    this.observacoes = obj;
  }

  removerItem(obj?: any) {
    this.dialogService.confirm(`Deseja realmente excluir este item?`, () => {
      const index: number = this.dataSet.indexOf(obj);
      if (index !== -1) {
        this.dataSet.splice(index, 1);
        this.enviarDados();
      }
    })
  }

  enviarDados() {
    // Preparar os dados relevantes para enviar
    // console.log(this.dataSet);
    const dadosPreparados = this.dataSet.map((item: any) => ({
      id: item.id,
      textoObservacao: item.textoObservacao
    }));

    // console.log(dadosPreparados);
    this.dadosObservacoesEmit.emit(dadosPreparados);
    this.entidadeSharedDataService.setObservacao(dadosPreparados);
    this.entidadeForm.get('entidadeObservacoes')?.setValue(dadosPreparados);
  }
}
